define("shared/components/shared/plan-recommendation/option-card", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <label
    class={{concat-classes "cPR--optionCard" (if @isSelected "is--active")}}
    data-test-id="plan-recommendation-option"
    for={{@inputId}}
    ...attributes
    {{on "mouseup" this.handleMouseup}}
  >
    <input
      checked={{@isSelected}}
      class="cPR--optionCard__input"
      data-test-id="plan-recommendation-option-input"
      id={{@inputId}}
      name={{@groupName}}
      type="radio"
      {{on "click" this.handleClick}}
      {{on "keydown" this.handleKeydown}}
    />
    <span class="cPR--optionCard__label">{{@label}}</span>
  </label>
  */
  {
    "id": "xf1m8qMx",
    "block": "[[[11,\"label\"],[16,0,[28,[37,0],[\"cPR--optionCard\",[52,[30,1],\"is--active\"]],null]],[24,\"data-test-id\",\"plan-recommendation-option\"],[16,\"for\",[30,2]],[17,3],[4,[38,2],[\"mouseup\",[30,0,[\"handleMouseup\"]]],null],[12],[1,\"\\n  \"],[11,\"input\"],[16,\"checked\",[30,1]],[24,0,\"cPR--optionCard__input\"],[24,\"data-test-id\",\"plan-recommendation-option-input\"],[16,1,[30,2]],[16,3,[30,4]],[24,4,\"radio\"],[4,[38,2],[\"click\",[30,0,[\"handleClick\"]]],null],[4,[38,2],[\"keydown\",[30,0,[\"handleKeydown\"]]],null],[12],[13],[1,\"\\n  \"],[10,1],[14,0,\"cPR--optionCard__label\"],[12],[1,[30,5]],[13],[1,\"\\n\"],[13]],[\"@isSelected\",\"@inputId\",\"&attrs\",\"@groupName\",\"@label\"],false,[\"concat-classes\",\"if\",\"on\"]]",
    "moduleName": "shared/components/shared/plan-recommendation/option-card.hbs",
    "isStrictMode": false
  });
  let OptionCardComponent = _exports.default = (_class = class OptionCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      /**
       * Whether the click about to arrive began with a pointer. The click alone cannot say: Safari
       * before 18.2 dispatches keyboard activation as a MouseEvent, and so is the click a label
       * forwards to its hidden input. A pointer always sends mouseup first; a keyboard never does.
       */
      _defineProperty(this, "isPointerActivation", false);
    }
    handleMouseup() {
      this.isPointerActivation = true;
    }

    /** `click` rather than `change`: re-clicking the chosen answer must report again, and a radio fires no `change` for that. */
    handleClick() {
      this.args.onSelect(this.isPointerActivation);
      this.isPointerActivation = false;
    }

    /** Also clears a mouseup that never became a click (pressed elsewhere, released over the card). */
    handleKeydown(event) {
      this.isPointerActivation = false;
      if (event.key === 'Enter') {
        this.args.onSelect(true);
      }
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "handleMouseup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, OptionCardComponent);
});